import React from 'react';
import { Link } from 'react-router-dom';

function PolitiqueConfidentialitePage() {
    return (
        <main>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: "url('img/bg/breadcrumb_bg.jpg')" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h2 className="title">Politique de confidentialité</h2>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Politique de confidentialité</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="privacy-policy-area" style={{ padding: '100px 0', backgroundColor: '#fff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="privacy-policy-content">
                                <h3 className="title mb-4">Politique de confidentialité</h3>
                                <p className="mb-4">Mise à jour 18/12/2025</p>

                                <p>Chez Kaki, la protection de vos données personnelles est une priorité. Nous nous engageons à traiter vos informations avec la plus grande confidentialité, transparence et sécurité, conformément à la réglementation en vigueur.</p>

                                <h4 className="mt-4 mb-3">1. Responsable du traitement des données</h4>
                                <p>Le responsable du traitement des données collectées sur le site est :</p>
                                <p><strong>Kaki</strong></p>
                                <p>Marque enregistrée auprès de l’INNORPI</p>
                                <p>Contact : contact@kaki.tn</p>

                                <h4 className="mt-4 mb-3">2. Données personnelles collectées</h4>
                                <p>Nous pouvons être amenés à collecter les données suivantes :</p>
                                <ul>
                                    <li>Nom et prénom</li>
                                    <li>Adresse e-mail</li>
                                    <li>Numéro de téléphone</li>
                                    <li>Adresse de livraison et de facturation</li>
                                    <li>Informations liées aux commandes et paiements (sans conservation des données bancaires)</li>
                                    <li>Données de navigation (cookies, adresse IP, type de navigateur)</li>
                                </ul>
                                <p>Ces données sont collectées uniquement lorsque vous :</p>
                                <ul>
                                    <li>Passez une commande</li>
                                    <li>Créez un compte client</li>
                                    <li>Contactez notre service client</li>
                                    <li>Naviguez sur notre site</li>
                                </ul>

                                <h4 className="mt-4 mb-3">3. Finalité de la collecte des données</h4>
                                <p>Les données personnelles sont collectées pour les finalités suivantes :</p>
                                <ul>
                                    <li>Traitement et suivi des commandes</li>
                                    <li>Livraison des produits</li>
                                    <li>Gestion de la relation client et du service après-vente</li>
                                    <li>Amélioration de l’expérience utilisateur</li>
                                    <li>Communication commerciale (si consentement préalable)</li>
                                    <li>Respect des obligations légales et comptables</li>
                                </ul>

                                <h4 className="mt-4 mb-3">4. Confidentialité et non-divulgation</h4>
                                <p>Kaki s’engage à ne jamais vendre, louer ou céder vos données personnelles à des tiers à des fins commerciales.</p>
                                <p>Les données peuvent toutefois être partagées uniquement avec des partenaires strictement nécessaires à l’exécution du service (transporteurs, prestataires de paiement, hébergeurs), dans le respect de la confidentialité et de la sécurité.</p>

                                <h4 className="mt-4 mb-3">5. Sécurité des données</h4>
                                <p>Nous mettons en œuvre toutes les mesures techniques et organisationnelles nécessaires pour protéger vos données contre :</p>
                                <ul>
                                    <li>L’accès non autorisé</li>
                                    <li>La perte</li>
                                    <li>La modification</li>
                                    <li>La divulgation frauduleuse</li>
                                </ul>
                                <p>Les paiements sont traités via des plateformes sécurisées et Kaki ne conserve aucune donnée bancaire.</p>

                                <h4 className="mt-4 mb-3">6. Durée de conservation</h4>
                                <p>Les données personnelles sont conservées uniquement pour la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et conformément à les obligations légales en vigueur.</p>

                                <h4 className="mt-4 mb-3">7. Droits des utilisateurs</h4>
                                <p>Conformément à la réglementation applicable, vous disposez des droits suivants :</p>
                                <ul>
                                    <li>Droit d’accès à vos données</li>
                                    <li>Droit de rectification</li>
                                    <li>Droit de suppression</li>
                                    <li>Droit d’opposition ou de limitation du traitement</li>
                                    <li>Droit au retrait du consentement à tout moment</li>
                                </ul>
                                <p>Toute demande peut être adressée à : contact@kaki.tn</p>

                                <h4 className="mt-4 mb-3">8. Cookies</h4>
                                <p>Le site utilise des cookies afin de :</p>
                                <ul>
                                    <li>Améliorer la navigation</li>
                                    <li>Analyser l’audience</li>
                                    <li>Optimiser les performances du site</li>
                                </ul>
                                <p>Vous pouvez à tout moment configurer ou refuser les cookies via les paramètres de votre navigateur.</p>

                                <h4 className="mt-4 mb-3">9. Liens externes</h4>
                                <p>Le site peut contenir des liens vers des sites des réseaux sociaux. Kaki ne saurait être tenue responsable des politiques de confidentialité ou du contenu de ces sites.</p>

                                <h4 className="mt-4 mb-3">10. Modification de la politique de confidentialité</h4>
                                <p>Kaki se réserve le droit de modifier la présente politique à tout moment.</p>
                                <p>Toute modification prendra effet dès sa publication sur le site.</p>

                                <h4 className="mt-4 mb-3">11. Contact</h4>
                                <p>Pour toute question relative à la protection des données personnelles, vous pouvez nous contacter à :</p>
                                <p>📧 contact@kaki.tn</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default PolitiqueConfidentialitePage;
